import React, { useState, useEffect } from "react";
import Title from "../../../../components/common/Title/Title";
import AppRoutePath from "../../../../router/AppRoutePath";
import { Checkbox, InputNumber } from "antd";
import Cookies from "js-cookie";
import { Button } from "react-bootstrap";
import moment from "moment";
import {
  convertCategory,
  convertOutletList,
  convertToRoman,
} from "../../helpers/index";
import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import TextInput from "../../components/TextInput";
import MultipleSelect from "../../components/MultipleSelect";
import "../styles.css";
import RadioComponent from "../../components/RadioComponent";
import {
  changeInputRevaluation,
  dataBreadcrumb,
  pawnType,
  paymentType,
  tenorType,
} from "./constants";
import SelectCurrencyInput from "../../components/SelectCurrencyInput";
import RegulerInformation from "../../components/RegulerInformation";
import TenorCalculation from "../../components/TenorCalculation";
import ErrorDiv from "../../../../components/helpers/ErrorDiv";
import IsEmpty from "../../../../components/helpers/IsEmpty";
import { useHistory } from "react-router-dom";
import httpclient from "../../../../components/httpclient";
import SwalToast from "../../../../components/helpers/SwalToast";
import CustomBreadcrumb from "../../../../components/common/Breadcrumb/CustomBreadcrumb";
import ExtensionInformation from "../../components/ExtensionInformation";
import { convertTenorList } from "../../helpers/convertTenorList";
import NumberFormat from "react-number-format";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import { convertNotificationList } from "../../helpers/convertNotificationGroupList";

export default function AddCampaignExtension() {
  const history = useHistory();
  const [tenorList, setTenorList] = useState([]);
  const [campaignName, setCampaignName] = useState();
  const [submitting, setSubmitting] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState([
    "balloon_payment",
  ]);
  const [selectedTenor, setSelectedTenor] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState([]);
  const [selectedPawnType, setSelectedPawnType] = useState(pawnType[0].value);
  const [paymentTypeValue, setPaymentTypeValue] = useState(
    paymentType[0].value
  );
  const [tenorTypeValue, setTenorTypeValue] = useState(tenorType[0].value);
  const [inputRevaluasi, setInputRevaluasi] = useState(
    changeInputRevaluation[1].value
  );
  const [minLoanValue, setMinLoanValue] = useState();
  const [maxLoanValue, setMaxLoanValue] = useState();
  const [currencyCapitalLoan, setCurrencyCapitalLoan] = useState("percent");
  const [capitalLoanValue, setCapitalLoanValue] = useState();
  const [currencyFeeAdmin, setCurrencyFeeAdmin] = useState("percent");

  const [feeAdminRupiah, setFeeAdminRupiah] = useState();
  const [feeAdminPercent, setFeeAdminPercent] = useState();
  const [currencyFeeSavingInsurance, setCurrencyFeeSavingInsurance] =
    useState("percent");
  const [feeSavingInsuranceValue, setFeeSavingInsuranceValue] = useState();
  const [currencyRevaluasi, setCurrencyRevaluasi] = useState("percent");
  const [revaluasiValue, setRevaluasiValue] = useState();

  const [tenor, setTenor] = useState();
  const [tenorCalculation, setTenorCalculation] = useState([]);
  const [showTenorCalculation, setShowTenorCalculation] = useState(false);

  const [maxLate, setMaxLate] = useState();

  const [errorTenor, setErrorTenor] = useState();
  const [errorName, setErrorName] = useState();
  const [errorCategory, setErrorCategory] = useState();
  const [errorOutlet, setErrorOutlet] = useState();
  const [errorPawnType, setErrorPawnType] = useState();
  const [errorMinLoan, setErrorMinLoan] = useState();
  const [errorMaxLoan, setErrorMaxLoan] = useState();
  const [errorCapitalLoan, setErrorCapitalLoan] = useState();
  const [errorFeeAdmin, setErrorFeeAdmin] = useState();
  const [errorSavingInsurance, setErrorSavingInsurance] = useState();
  const [errorPaymentType, setErrorPaymentType] = useState();
  const [errorRevaluasi, setErrorRevaluasi] = useState();
  const [errorDate, setErrorDate] = useState();
  const [dateValue, setDateValue] = useState([]);
  const [errorNotifGroup, setErrorNotifGroup] = useState();
  const [notificationGroups, setNotificationGroups] = useState([]);
  const [selectedNotifGroup, setSelectedNotifGroup] = useState();
  const [gracePeriod, setGracePeriod] = useState();
  const [errorGracePeriod, setErrorGracePeriod] = useState();
  const [errorMaxLate, setErrorMaxLate] = useState();

  useEffect(() => {
    getCategory();
    getNotificationGroup();
  }, []);

  useEffect(() => {
    getOutlet();
    getAvailableTenor();
  }, [selectedCategory, selectedOutlet]);

  const getNotificationGroup = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setNotificationGroups(convertNotificationList(response.data.data));
      }
    );
  };

  useEffect(() => {
    if (!IsEmpty(tenorTypeValue) && !IsEmpty(selectedPawnType))
      getAvailableTenor();
  }, [tenorTypeValue, selectedPawnType]);

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryList(convertCategory(response.data.data.items));
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-extension/available-outlet`;
    httpclient
      .GET(url, {
        product_category_id: selectedCategory?.map((x) =>
          parseInt(x.product_category_id)
        ),
      })
      .then((response) => {
        setOutletList(convertOutletList(response?.data?.data));
      });
  };

  const getAvailableTenor = () => {
    console.log({
      product_category_id: selectedCategory?.map((x) =>
        parseInt(x.product_category_id)
      ),
      outlet_id: selectedOutlet?.map((x) => parseInt(x.value)),
    });
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-extension/available-tenor`;
    httpclient
      .GET(url, {
        product_category_id: selectedCategory?.map((x) =>
          parseInt(x.product_category_id)
        ),
        outlet_id: selectedOutlet?.map((x) => parseInt(x.value)),
        gadai_type: selectedPawnType,
      })
      .then((response) => {
        // console.log("convert..")
        // console.log(selectedPawnType)
        console.log(response.data.data);
        setTenorList(
          convertTenorList(response?.data?.data, selectedPawnType, true)
        );
      });
  };

  const handleSelectChange = (field, data) => {
    if (field === "outlet") {
      let outlet = [];
      // data.map((item) => {
      //   outlet.push({
      //     outlet_id: item.value,
      //     label: item.label,
      //     value: item.value,
      //   });
      //   setSelectedOutlet(data);
      // });
      setSelectedOutlet(data);
    } else if (field === "category") {
      let category = [];
      category.push({ product_category_id: data.value });
      setSelectedCategory(category);
    } else if (field === "tenor") {
      let tenorDays = [];
      if (data.length === 0) {
        setSelectedTenor([]);
      } else {
        data.map((item) => {
          tenorDays.push({ days: item.value });
          setSelectedTenor(tenorDays);
        });
      }
    } else if (field === "notification") {
      setSelectedNotifGroup(data.value);
    }
  };

  const onChangeRadio = (id, data) => {
    if (id === "paymentType") {
      setPaymentTypeValue(data.value);
    } else if (id === "tenorType") {
      setTenorTypeValue(data.value);
    } else if (id === "inputRevaluasi") {
      setInputRevaluasi(data.value);
    } else if (id === "pawnType") {
      setSelectedOutlet([]);
      setSelectedPawnType(data.value);
    }
  };

  const handleChangeInput = (id, data) => {
    if (data) {
      let { floatValue } = data;
      if (id === "capitalLoan") {
        setCapitalLoanValue(floatValue);
      } else if (id === "feeSavingInsurance") {
        setFeeSavingInsuranceValue(floatValue);
      } else if (id === "revaluasi") {
        setRevaluasiValue(floatValue);
      }
    }
  };

  const handleChangeCurrency = (id, data) => {
    if (id === "capitalLoan") {
      setCurrencyCapitalLoan(data);
    } else if (id === "feeAdmin") {
      setCurrencyFeeAdmin(data);
    } else if (id === "feeSavingInsurance") {
      setCurrencyFeeSavingInsurance(data);
    } else if (id === "revaluasi") {
      setCurrencyRevaluasi(data);
    }
  };

  const handleBlur = (event) => {
    console.log(event);
  };

  const validate = () => {
    let validate = true;
    setErrorName();
    setErrorCategory();
    setErrorOutlet();
    setErrorTenor();
    setErrorPawnType();
    setErrorMinLoan();
    setErrorMaxLoan();
    setErrorCapitalLoan();
    setErrorFeeAdmin();
    setErrorSavingInsurance();
    setErrorPaymentType();
    setErrorRevaluasi();
    setErrorDate();
    setErrorNotifGroup();
    setErrorGracePeriod();
    setErrorMaxLate();

    if (IsEmpty(campaignName)) {
      validate = false;
      setErrorName("Nama Harus Diisi");
    }
    if (selectedPaymentType.length === 0) {
      validate = false;
      setErrorPaymentType("Jenis Pembayaran Harus Dipilih");
    }
    if (selectedCategory.length === 0) {
      validate = false;
      setErrorCategory("Kategori Produk Harus Dipilih");
    }
    if (selectedPawnType !== "pick_up") {
      if (selectedOutlet.length === 0) {
        validate = false;
        setErrorOutlet("Outlet Harus Dipilih");
      }
    }
    if (selectedTenor.length === 0) {
      validate = false;
      setErrorTenor("Tenor Pinjaman Harus Dipilih");
    }
    if (tenorTypeValue === "reguler") {
      if (tenor > 120) {
        validate = false;
        setErrorTenor("Jenis Tenor Reguler Maksimal 120 Hari");
      }
    }
    if (selectedPawnType.length === 0) {
      validate = false;
      setErrorPawnType("Jenis Gadai Harus Dipilih");
    }
    if (IsEmpty(minLoanValue) && minLoanValue !== 0) {
      validate = false;
      setErrorMinLoan("Minimum Pinjaman Harus Diisi");
    }
    if (IsEmpty(maxLoanValue) && maxLoanValue !== 0) {
      validate = false;
      setErrorMaxLoan("Maksimum Pinjaman Harus Diisi");
    }
    if (IsEmpty(capitalLoanValue) && capitalLoanValue !== 0) {
      validate = false;
      setErrorCapitalLoan("Biaya Sewa Modal Harus Diisi");
    }
    if (
      (IsEmpty(feeAdminPercent) && feeAdminPercent !== 0) ||
      (IsEmpty(feeAdminRupiah) && feeAdminRupiah !== 0)
    ) {
      validate = false;
      setErrorFeeAdmin("Biaya Administrasi Harus Diisi");
    }
    if (IsEmpty(feeSavingInsuranceValue) && feeSavingInsuranceValue !== 0) {
      validate = false;
      setErrorSavingInsurance("Biaya Simpan & Asuransi Harus Diisi");
    }
    if (IsEmpty(revaluasiValue) && revaluasiValue !== 0) {
      validate = false;
      setErrorRevaluasi("Nilai Revaluasi Harus Diisi");
    }
    if (dateValue.length === 0) {
      validate = false;
      setErrorDate("Tanggal Berlaku Harus Diisi");
    }
    if (IsEmpty(selectedNotifGroup)) {
      validate = false;
      setErrorNotifGroup("Notifikasi Harus Dipilih");
    }
    if (IsEmpty(gracePeriod)) {
      validate = false;
      setErrorGracePeriod("Masa Tenggang Harus Diisi");
    }
    if (IsEmpty(maxLate) && maxLate !== 0) {
      validate = false;
      setErrorMaxLate("Maksimum Keterlambatan Harus Diisi");
    }
    return validate;
  };

  const onSubmit = () => {
    if (!validate()) return;
    let outlet = [];
    selectedOutlet.map((item) => {
      outlet.push({
        outlet_id: item.value,
      });
    });

    let url = `${process.env.REACT_APP_BASE_API_URL}promo-extension`;
    let data = {
      is_able_input_revaluation: inputRevaluasi,
      name: campaignName,
      payment_type: selectedPaymentType.toString(),
      tenor_type: tenorTypeValue,
      gadai_type: selectedPawnType.toString(),
      description: " ",
      max_loan_rupiah: parseInt(maxLoanValue),
      min_loan_rupiah: parseInt(minLoanValue),
      fee_admin_rupiah: parseInt(feeAdminRupiah),
      fee_admin_percentage: parseFloat(feeAdminPercent),
      fee_saving_assurance_rupiah:
        currencyFeeSavingInsurance === "rupiah"
          ? parseInt(feeSavingInsuranceValue)
          : 0,
      fee_saving_assurance_percentage:
        currencyFeeSavingInsurance === "percent"
          ? parseFloat(feeSavingInsuranceValue)
          : 0,
      capital_loan_rupiah:
        currencyCapitalLoan === "rupiah" ? parseInt(capitalLoanValue) : 0,
      capital_loan_percentage:
        currencyCapitalLoan === "percent" ? parseFloat(capitalLoanValue) : 0,
      promo_extension_tenors: selectedTenor,
      promo_extension_outlets:
        selectedPawnType === "pick_up" ? [{ outlet_id: 0 }] : outlet,
      promo_extension_products: selectedCategory,
      revaluation_rupiah:
        currencyRevaluasi === "rupiah" ? parseInt(revaluasiValue) : 0,
      revaluation_percentage:
        currencyRevaluasi === "percent" ? parseFloat(revaluasiValue) : 0,
      start_date: dateValue[0]?.format("YYYY-MM-DD"),
      end_date: dateValue[1]?.format("YYYY-MM-DD"),
      notification_group_id: selectedNotifGroup,
      grace_period: parseInt(gracePeriod),
      max_late: parseInt(maxLate),
    };
    console.log(data);
    setSubmitting(true);
    httpclient
      .POST(url, data)
      .then((response) => {
        console.log(response);
        history.push(AppRoutePath.CAMPAIGN);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error?.response?.data?.error?.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const handleDateChange = (event) => {
    setDateValue([moment(event[0]._d), moment(event[1]._d)]);
  };

  return (
    <div className="px-3">
      <div className="pt-4 d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Tambah Promo Offer Perpanjangan"} />
          <CustomBreadcrumb current={dataBreadcrumb} />
        </div>
      </div>
      <div className="container-campaign">
        <div className="container-input-1">
          <div className="container-input my-3">
            <TextInput
              label="Nama Promo"
              onChange={(e) => setCampaignName(e.target.value)}
            />
            <ErrorDiv error={errorName} />
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div className="container-sk d-flex">
              <div className="col-6 px-0">
                <RadioComponent
                  value={selectedPawnType}
                  options={pawnType}
                  label="Jenis Gadai"
                  onChange={onChangeRadio}
                  id="pawnType"
                />
              </div>
            </div>
            <div className="container-sk">
              <div className="label-campaign">Syarat & Ketentuan</div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <MultipleSelect
                    isMulti={false}
                    options={categoryList}
                    label="Kategori Produk"
                    id={"category"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorCategory} />
                </div>
                <div className="col-6 pr-0">
                  <MultipleSelect
                    isDisabled={selectedPawnType === "pick_up"}
                    isMulti={true}
                    options={outletList}
                    label="Outlet/Cabang"
                    id={"outlet"}
                    onSelectChange={handleSelectChange}
                    value={selectedOutlet}
                    defaultValue={selectedOutlet}
                  />
                  <ErrorDiv error={errorOutlet} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <p>Jenis Pembayaran</p>
                  <Checkbox.Group
                    value={selectedPaymentType}
                    defaultChecked={true}
                    className="pawn-type-checkbox"
                    options={paymentType}
                  // onChange={onChangePaymentType}
                  />
                  <ErrorDiv error={errorPaymentType} />
                </div>
                <div className="col-6 pr-0">
                  <RadioComponent
                    value={tenorTypeValue}
                    options={tenorType}
                    label="Jenis Tenor"
                    onChange={onChangeRadio}
                    id="tenorType"
                  />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <p>Minimal Pinjaman</p>
                  <div className="d-flex align-items-center">
                    <NumberFormat
                      isNumericString={true}
                      onValueChange={(e) => setMinLoanValue(e.floatValue)}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      style={{
                        marginRight: 5,
                        border: "0.75px solid #DCDCDC",
                        width: "100%",
                        paddingLeft: 6,
                        height: 36,
                        borderRadius: 5,
                      }}
                    />
                    <div>Rupiah</div>
                  </div>
                  <ErrorDiv error={errorMinLoan} />
                </div>
                <div className="col-6 pr-0">
                  <p>Maksimal Pinjaman</p>
                  <div className="d-flex align-items-center">
                    <NumberFormat
                      isNumericString={true}
                      onValueChange={(e) => setMaxLoanValue(e.floatValue)}
                      thousandSeparator={"."}
                      decimalSeparator={","}
                      style={{
                        marginRight: 5,
                        border: "0.75px solid #DCDCDC",
                        width: "100%",
                        paddingLeft: 6,
                        height: 36,
                        borderRadius: 5,
                      }}
                    />
                    <div>Rupiah</div>
                  </div>
                  <ErrorDiv error={errorMaxLoan} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <MultipleSelect
                    isMulti={true}
                    options={tenorList}
                    label="Tenor Pinjaman"
                    id={"tenor"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorTenor} />
                </div>

                <div className="col-6 pr-0">
                  <MultipleSelect
                    isMulti={false}
                    options={notificationGroups}
                    label="Notifikasi"
                    id={"notification"}
                    onSelectChange={handleSelectChange}
                  />
                  <ErrorDiv error={errorNotifGroup} />
                </div>
              </div>
            </div>
            <hr style={{ border: "1px dashed #DCDCDC" }} />
            <div className="container-sk">
              <div className="label-campaign">Promo yang Didapat</div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="capitalLoan"
                    label="Biaya Sewa Modal"
                    defaultValue={currencyCapitalLoan}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorCapitalLoan} />
                </div>
                <div className="col-6 pr-0">
                  <p>Biaya Administrasi</p>
                  <div className="d-flex">
                    <div className="col-6 pl-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminPercent}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminPercent(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -20, marginTop: 6 }}
                      >
                        %
                      </p>
                    </div>
                    <div className="col-6 pl-1 pr-0 d-flex align-items-center">
                      <NumberFormat
                        value={feeAdminRupiah}
                        isNumericString={true}
                        onValueChange={(e) => setFeeAdminRupiah(e.floatValue)}
                        thousandSeparator={"."}
                        decimalSeparator={","}
                        style={{
                          height: 32,
                          border: "0.75px solid #DCDCDC",
                          width: "100%",
                          paddingLeft: 6,
                        }}
                      />
                      <p
                        style={{ color: "#000", marginLeft: -50, marginTop: 6 }}
                      >
                        Rupiah
                      </p>
                    </div>
                  </div>
                  <ErrorDiv error={errorFeeAdmin} />
                </div>
              </div>

              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <SelectCurrencyInput
                    id="feeSavingInsurance"
                    label="Biaya Simpan & Asuransi"
                    defaultValue={currencyFeeSavingInsurance}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorSavingInsurance} />
                </div>
                <div className="col-6 pr-0">
                  <SelectCurrencyInput
                    id="revaluasi"
                    label="Nilai Revaluasi"
                    defaultValue={currencyRevaluasi}
                    onChangeCurrency={handleChangeCurrency}
                    onChange={handleChangeInput}
                  />
                  <ErrorDiv error={errorRevaluasi} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <RadioComponent
                    value={inputRevaluasi}
                    options={changeInputRevaluation}
                    label="Izinkan Ubah Nilai Revaluasi"
                    onChange={onChangeRadio}
                    id="inputRevaluasi"
                  />
                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    value={gracePeriod}
                    suffix="Hari"
                    label="Masa Tenggang"
                    onChange={(e) => setGracePeriod(e.target.value)}
                  />
                  <ErrorDiv error={errorGracePeriod} />
                </div>
              </div>
              <div className="container-sk d-flex">
                <div className="col-6 px-0">
                  <p>Tanggal Berlaku</p>
                  <CustomDatePicker
                    id={"date"}
                    isRangePicker
                    width="50%"
                    onInputChange={handleDateChange}
                    value={dateValue}
                  />
                  <ErrorDiv error={errorDate} />
                </div>
                <div className="col-6 pr-0">
                  <TextInput
                    suffix="Hari"
                    label="Maksimum Keterlambatan"
                    onChange={(e) => setMaxLate(e.target.value)}
                  />
                  <ErrorDiv error={errorMaxLate} />
                </div>
              </div>
            </div>
          </div>

          <div className="ml-auto d-flex align-items-center justify-content-end">
            <Button
              onClick={() => history.push(AppRoutePath.CAMPAIGN, { list: 'extension' })}
              className="btn-action"
              style={{
                width: 120,
                height: 36,
                margin: 5,
                background: "#fff",
                border: "0.75px solid #DCDCDC",
                color: "#2C465C",
              }}
            >
              Kembali
            </Button>
            <Button
              variant="primary"
              className="btn-action btn-add"
              style={{ width: 120, height: 36, margin: 5 }}
              onClick={onSubmit}
            >
              Tambah
            </Button>
          </div>
        </div>

        <ExtensionInformation />
      </div>
    </div>
  );
}
